<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">{{ isEditing ? 'Editar Grupo' : 'Crear Grupo' }}</p>
              <argon-button color="success" size="sm" class="ms-auto" @click="save" :disabled="isSaving">Guardar</argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-8">
                <label for="group-name" class="form-control-label">Nombre</label>
                <argon-input type="text" id="group-name" v-model="group.name" autocomplete="off" />
              </div>
              <div class="col-md-4">
                <label for="group-status" class="form-control-label">Estado</label>
                <select id="group-status" class="form-select" v-model="group.status">
                  <option value="1">Activo</option>
                  <option value="0">Inactivo</option>
                </select>
              </div>
              <div class="col-md-12">
                <label for="group-description" class="form-control-label">Descripción</label>
                <argon-input type="text" id="group-description" v-model="group.description" autocomplete="off" />
              </div>
              <div class="col-md-12">
                <label for="group-oficio" class="form-control-label">Oficios</label>
                <select id="group-oficio" ref="oficiosSelect" class="form-select" multiple style="width:100%">
                  <option v-for="oficio in oficios" :key="oficio.id" :value="oficio.id">
                    {{ oficio.name }}
                  </option>
                </select>
                <small class="text-muted">El grupo puede recibir tareas de cualquiera de estos oficios.</small>
              </div>

              <hr class="my-4">

              <div class="col-md-12 my-3">
                <label class="form-control-label">
                  Integrantes <span v-if="groupMembers.length">({{ groupMembers.length }})</span>
                </label>
                <div class="row">
                  <div class="col-md-8">
                    <label for="member-search" class="form-control-label">Agregar por búsqueda</label>
                    <select id="member-search" ref="memberSearchSelect" class="form-select" style="width:100%"></select>
                    <small class="text-muted">Busca por nombre o número de cédula (incluye usuarios de cualquier
                      oficio).</small>
                  </div>
                  <div class="col-md-4 d-flex align-items-start">
                    <argon-button color="success" size="sm" @click="addSelectedMember" :disabled="isAddingMember">
                      Agregar <i class="fa fa-plus ms-1"></i>
                    </argon-button>
                  </div>
                </div>

                <div class="table-responsive p-0 mt-3" v-if="groupMembers.length > 0">
                  <table class="table align-items-center mb-0">
                    <thead>
                      <tr>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Integrante</th>
                        <th
                          class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cédula
                        </th>
                        <th
                          class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Correo
                        </th>
                        <th
                          class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Opciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="member in groupMembers" :key="member.id">
                        <td>
                          <h6 class="mb-0 text-sm">{{ member.name }}</h6>
                        </td>
                        <td class="align-middle text-center text-sm">
                          <span class="text-secondary text-xs font-weight-bold">{{ member.document || '—' }}</span>
                        </td>
                        <td class="align-middle text-center text-sm">
                          <span class="text-secondary text-xs font-weight-bold">{{ member.email }}</span>
                        </td>
                        <td class="align-middle text-center">
                          <a @click="removeMember(member.id)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Quitar del grupo">
                            <i class="fa fa-trash"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else class="text-secondary text-sm mt-2">
                  Aún no hay integrantes. Use la búsqueda para agregarlos.
                </div>
              </div>

              <div class="col-md-12" v-if="groupMembers.length > 0">
                <small class="text-muted">
                  Al asignar una tarea a este grupo, el valor total se dividirá entre
                  {{ groupMembers.length }} integrante(s).
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
</style>

<script>
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import authHeader from "../../../services/auth-header";

export default {
  name: "Group Create",
  data() {
    return {
      isSaving: false,
      isAddingMember: false,
      group: {
        id: 0,
        name: '',
        description: '',
        oficio_ids: [],
        status: '1',
      },
      oficios: [],
      groupMembers: [],
      memberSearchResults: [],
      selectedMemberId: null,
    };
  },
  components: { ArgonInput, ArgonButton },
  computed: {
    isEditing() {
      return this.group.id > 0;
    },
  },
  methods: {
    async getOficios() {
      this.oficios = await this.$store.dispatch('users/getOficios');
    },
    async addSelectedMember() {
      // select2 entrega el id como string; comparar numéricamente
      const selectedId = Number(this.selectedMemberId);
      const user = (this.memberSearchResults || []).find(u => u.id === selectedId);
      if (!user) {
        await Swal.fire({ icon: 'warning', title: 'Atención', text: 'Seleccione un integrante de la búsqueda.' });
        return;
      }
      if (this.groupMembers.some(m => m.id === user.id)) {
        await Swal.fire({ icon: 'info', title: 'Ya agregado', text: `${user.name} ya es integrante del grupo.` });
        return;
      }

      this.isAddingMember = true;
      try {
        this.groupMembers.push(user);

        // Limpiar la búsqueda
        this.selectedMemberId = null;
        if (this.$refs.memberSearchSelect) {
          $(this.$refs.memberSearchSelect).val(null).trigger('change');
        }
      } finally {
        this.isAddingMember = false;
      }
    },
    removeMember(memberId) {
      this.groupMembers = this.groupMembers.filter(m => m.id !== memberId);
    },
    initOficiosSelect() {
      if (!this.$refs.oficiosSelect) {
        return;
      }
      $(this.$refs.oficiosSelect).select2({
        placeholder: 'Seleccione uno o varios oficios',
        closeOnSelect: false,
        width: '100%',
      }).val(this.group.oficio_ids.map(String)).trigger('change')
        .on('change', () => {
          this.group.oficio_ids = ($(this.$refs.oficiosSelect).val() || []).map(Number);
        });
    },
    initMemberSearch() {
      if (!this.$refs.memberSearchSelect) {
        return;
      }
      $(this.$refs.memberSearchSelect).select2({
        placeholder: 'Buscar por nombre o cédula...',
        minimumInputLength: 2,
        allowClear: true,
        ajax: {
          url: `${process.env.VUE_APP_API_BASE_URL}/groups/available-users`,
          dataType: 'json',
          headers: authHeader(),
          delay: 250,
          data: (params) => ({
            search: params.term || '',
          }),
          processResults: (data) => {
            // Ocultar quienes ya son integrantes del grupo
            const memberIds = this.groupMembers.map(m => m.id);
            const results = (data || []).filter(u => !memberIds.includes(u.id));
            this.memberSearchResults = results;
            return {
              results: results.map(u => ({
                id: u.id,
                text: `${u.name} - ${u.document || 'sin cédula'}`,
              })),
            };
          },
        },
      }).on('change', () => {
        const selection = $(this.$refs.memberSearchSelect).select2('data')[0];
        this.selectedMemberId = selection ? selection.id : null;
      });
    },
    async save() {
      if (this.isSaving) {
        return;
      }

      if (!this.group.name || !this.group.name.trim()) {
        await Swal.fire({ icon: 'warning', title: 'Atención', text: 'El nombre del grupo es obligatorio.' });
        return;
      }
      if (this.groupMembers.length === 0) {
        await Swal.fire({ icon: 'warning', title: 'Atención', text: 'Debe agregar al menos un integrante al grupo.' });
        return;
      }

      try {
        this.isSaving = true;
        Swal.fire({
          title: 'Guardando...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const payload = {
          id: this.group.id,
          name: this.group.name,
          description: this.group.description || null,
          oficio_ids: this.group.oficio_ids,
          status: this.group.status,
          user_ids: this.groupMembers.map(m => m.id),
        };
        const response = await this.$store.dispatch("groups/save", payload);

        Swal.close();

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El grupo ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push({ name: 'Groups' });
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el grupo');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al guardar el grupo:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el grupo',
        });
      } finally {
        this.isSaving = false;
      }
    }
  },
  async mounted() {
    await this.getOficios();

    const data = this.$route.params.group;

    if (data) {
      try {
        const params = JSON.parse(data);
        if (params && params.id) {
          this.group.id = params.id || 0;
          this.group.name = params.name || '';
          this.group.description = params.description || '';
          this.group.oficio_ids = (params.oficios || []).length
            ? params.oficios.map(o => Number(o.id))
            : (params.oficio_id ? [Number(params.oficio_id)] : []);
          this.group.status = String(params.status ?? '1');
          this.groupMembers = params.users || [];
        }
      } catch (error) {
        console.error("Error al parsear los datos del grupo:", error);
      }
    }

    this.$nextTick(() => {
      this.initOficiosSelect();
      this.initMemberSearch();
    });

    this.$store.state.isAbsolute = false;
  },
  beforeMount() {
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
  },
};
</script>
